import * as React from "react";
import type { SVGProps } from "react";
const SvgTransmitterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="transmitter_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M860.587 393.813 263.253 147.2A128 128 0 0 0 92.587 305.067L158.293 512 90.88 718.933a128 128 0 0 0 34.56 134.4 128 128 0 0 0 85.333 34.134c16.854 0 33.536-3.328 49.067-9.814L859.307 631.04a128 128 0 0 0 0-236.373l1.28-.854zM228.693 797.867a42.667 42.667 0 0 1-45.226-8.107 42.667 42.667 0 0 1-11.52-42.667l62.293-192.426h585.813l-591.36 243.2zm5.547-328.534-63.573-190.72a42.667 42.667 0 0 1 11.52-42.666 42.667 42.667 0 0 1 47.786-9.814l590.08 243.2H234.24z"
    />
  </svg>
);
export default SvgTransmitterIcon;
